import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { NbDialogService } from '@nebular/theme';
import { RequestConfirmationV2Component } from "../request-confirmation-v2/request-confirmation-v2.component";
import { AppLocalStorage } from "../../../../../@core/utils/local-storage.util";

@Component({
    selector: 'ltts-approval-v2',
    templateUrl: './approval-v2.component.html',
    styleUrls: ['./approval-v2.component.scss']
})
export class ApprovalV2Component implements OnInit {
    reqForApprovalsData: any;
    employeeID: any;
    selectedCategory: any;
    requestsLoading: boolean;
     headerLabels: { [key: string]: string } = {
        'Attendance Request': 'Attendance Regularization',
        'Leave Request': 'Leave Approval',
        'Car Request': 'Cab Approval',
        'Accommodation Request': 'Accommodation Approval',
        'Synergy Request': 'Synergy Approval'
    };



    @Output() fetchRequest = new EventEmitter<any>();
    @Output() accordionStateChange = new EventEmitter<boolean>();

    constructor(private cdRef: ChangeDetectorRef, private dialogService: NbDialogService,) { }

    @Input()
    set approvalData(value) {
        if (value) {
            this.reqForApprovalsData = value;
            this.cdRef.detectChanges();
        }
    }

    @Input()
    set loadingData(value) {
        // if(value){
        this.requestsLoading = value;
        this.cdRef.detectChanges();
        // }
    }

    ngOnInit(): void {
        const loginEmail = AppLocalStorage.get("ACCOUNT_DATA", "ACCOUNT_DATA");
        this.employeeID = loginEmail.profile.employeeId;
    }

    onAccordionToggle(isExpanded: boolean) {
        // collapsedChange emits true when collapsed, false when expanded
        // So we need to invert it: when collapsed is false, it's expanded
        this.accordionStateChange.emit(!isExpanded);
    }

    approveAll(event) {
        const reqBody = {
            category: event.categoryName,
            userId: this.employeeID,
            ticketID: "",
            employeeId: 0,
            fromDate: "",
            toDate: "",
        };

        this.dialogService.open(RequestConfirmationV2Component, {
            context: {
                title: 'Are you sure you want to approve all requests?',
                reqData: reqBody,
                action: 'approveAll'
            },
        }).onClose.subscribe((value) => {
            if (value) {
                this.fetchRequest.emit();
            }
        });


    }

    approveRequest(selectedCategory) {
        const me = this;
        this.selectedCategory = selectedCategory;
        this.fetchRequest.emit();
        return;

    }

    declineRequest(selectedCategory) {
        this.selectedCategory = selectedCategory;
        this.fetchRequest.emit();
        return;

    }
}
